import { render, staticRenderFns } from "./QurbanPaymentConfirm.vue?vue&type=template&id=73436d95"
import script from "./QurbanPaymentConfirm.vue?vue&type=script&lang=js"
export * from "./QurbanPaymentConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports